var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackLayoutHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.09814C1 1.6149 1.39175 1.22314 1.875 1.22314H14.125C14.6082 1.22314 15 1.6149 15 2.09814V3.84814C15 4.33139 14.6082 4.72314 14.125 4.72314H1.875C1.39175 4.72314 1 4.33139 1 3.84814V2.09814Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.09814C1 8.6149 1.39175 8.22314 1.875 8.22314H7.125C7.60825 8.22314 8 8.6149 8 9.09814V14.3481C8 14.8314 7.60825 15.2231 7.125 15.2231H1.875C1.39175 15.2231 1 14.8314 1 14.3481V9.09814Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.09814C11.5 8.6149 11.8918 8.22314 12.375 8.22314H14.125C14.6082 8.22314 15 8.6149 15 9.09814V14.3481C15 14.8314 14.6082 15.2231 14.125 15.2231H12.375C11.8918 15.2231 11.5 14.8314 11.5 14.3481V9.09814Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLayoutHome);
export default __webpack_public_path__ + "static/media/blackLayoutHome.f05528ee2440014df85d5a0bc46b5126.svg";
export { ForwardRef as ReactComponent };